import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

const ROLE_STYLES = {
  Styreleder: "bg-primary/10 text-primary border-primary/20",
  Nestleder: "bg-primary/10 text-primary border-primary/20",
  Styremedlem: "bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/20",
  Varamedlem: "bg-muted text-muted-foreground border-border",
  "Daglig leder": "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20",
  Aksjonær: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20",
};

export function RoleBadge({ role, className }) {
  return (
    <span
      data-testid="role-badge"
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        ROLE_STYLES[role] || "bg-muted text-muted-foreground border-border",
        className
      )}
    >
      {role}
    </span>
  );
}

const STATUS_STYLES = {
  planlagt: "bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/20",
  innkalt: "bg-teal-500/10 text-teal-700 dark:text-teal-300 border-teal-500/20",
  gjennomfort: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20",
  signert: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20",
  apen: "bg-muted text-muted-foreground border-border",
  pagar: "bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/20",
  ferdig: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20",
};

const STATUS_LABELS = {
  planlagt: "Planlagt",
  innkalt: "Innkalt",
  gjennomfort: "Gjennomført",
  signert: "Signert",
  apen: "Åpen",
  pagar: "Pågår",
  ferdig: "Ferdig",
};

export function StatusBadge({ status, className }) {
  return (
    <span
      data-testid="status-badge"
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        STATUS_STYLES[status] || "bg-muted text-muted-foreground border-border",
        className
      )}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function SourceBadge({ source, className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border border-border bg-secondary px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-muted-foreground",
        className
      )}
    >
      {source}
    </span>
  );
}

export function VerifiedBadge({ label = "Verifisert med BankID", className, testId = "verified-badge" }) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-emerald-500/25 bg-emerald-500/10 px-2.5 py-0.5 text-xs font-medium text-emerald-700 dark:text-emerald-300",
        className
      )}
    >
      <ShieldCheck className="h-3.5 w-3.5" /> {label}
    </span>
  );
}
